import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Api from './api';
import Main from './pages/main/Main';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <HelmetProvider>
      <Api>
        <Router>
          <Routes>
            <Route path='/:alias' element={<Main />} />
          </Routes>
        </Router>
      </Api>
    </HelmetProvider>
  );
}

export default App;
